import styled from '@emotion/styled'
import { motion } from 'framer-motion'
import React, { memo } from 'react'
import { useInView } from 'react-intersection-observer'

export interface Props {
  icon?: string
  label?: string
}

export const Service = memo(function Service({ icon, label }: Props) {
  if (!icon || !label) {
    return null
  }

  const [ref, isVisible] = useInView({ threshold: 0.25 })
  const variants = {
    visible: {
      duration: 0.6,
      opacity: 1,
      y: 0,
    },
    hidden: {
      opacity: 0,
      y: '3.75rem',
    },
  }

  return (
    <Container
      ref={ref}
      animate={isVisible ? 'visible' : 'hidden'}
      transition={{
        duration: 0.5,
      }}
      variants={variants}
    >
      {icon ? <Icon src={icon} alt={label} width="36" height="36" /> : null}
      {label ? <Label>{label}</Label> : null}
    </Container>
  )
})

const Container = styled(motion.div)`
  display: flex;
  align-items: center;
  width: 50%;
  margin-top: 3.25rem;
  padding-right: 1.875rem;

  @media (max-width: 1023px) {
    justify-content: center;
  }

  @media (max-width: 767px) {
    width: 100%;
    padding-right: 0;
  }
`

const Icon = styled.img`
  width: 2.25rem;
  height: auto;
  max-height: 2.25rem;
  margin-right: 1.5rem;
`

const Label = styled.div`
  width: calc(100% - 3.125rem);
  color: ${({ theme }) => theme.colors.variants.neutralDark4};
  font-family: ${({ theme }) => theme.fontFamily.paragraph};
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.875rem;

  @media (max-width: 1023px) {
    width: auto;
  }
`
